// @flow

export { DisplayPayingWithEbanx } from './display-paying-with-ebanx';
